export default __webpack_public_path__ + "static/media/w.532e83a9.png";